export default "__VITE_PUBLIC_ASSET__848631dc__"